export default __webpack_public_path__ + "static/Content-image-42abeebd2a46959bc86d166987a4db76.webp";